<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2017 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2017.</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">26 25 24 23 22 21 20 19 18 17    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-42278-7 (cloth)</p>
<p class="crt"><span class="sm">I</span>SBN-13: 978-0-226-42281-7 (e-book)</p>
<p class="crt">DOI: 10.7208/chicago/9780226422817.001.0001</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Akerman, James R., editor.</p>
<p class="cip">Title: Decolonizing the map : cartography from colony to nation / edited by James R. Akerman.</p>
<p class="cip">Other titles: Kenneth Nebenzahl, Jr., lectures in the history of cartography.</p>
<p class="cip">Description: Chicago : The University of Chicago Press, 2017. | Series: Kenneth Nebenzahl, Jr., lectures in the history of cartography | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2016030112 | ISBN 9780226422787 (cloth : alk. paper) | ISBN 9780226422817 (e-book)</p>
<p class="cip">Subjects: LCSH: Cartography—Political aspects. | Decolonization.</p>
<p class="cip">Classification: LCC GA108.7 .D44 2017 | DDC 526—dc23 LC record available at <a class="url" href="https://lccn.loc.gov/2016030112" target="_blank">https://lccn.loc.gov/2016030112</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48–1992 (Permanence of Paper).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Akerman-0005.vue?c191a52e